import client from "../index.js";
import { GET_BLOCK, GET_BLOCKS } from "./query.js";
import { CREATE_BLOCK, UPDATE_BLOCK, DELETE_BLOCK } from "./mutation.js";

export const apiGetBlocks = (input) => {
  return client
    .query({
      query: GET_BLOCKS,
      variables: { input },
      fetchPolicy: "no-cache",
    })
    .then((res) => res?.data?.blocks);
};

export const apiGetBlock = (id) => {
  return client
    .query({
      query: GET_BLOCK,
      variables: { id },
      fetchPolicy: "no-cache",
    })
    .then((res) => res?.data?.block);
};

export const apiCreateBlock = (input) => {
  return client
    .mutate({
      mutation: CREATE_BLOCK,
      variables: { input },
      fetchPolicy: "no-cache",
    })
    .then((res) => res?.data?.createBlock?.block);
};

export const apiUpdateBlock = (input) => {
  return client
    .mutate({
      mutation: UPDATE_BLOCK,
      variables: { input },
      fetchPolicy: "no-cache",
    })
    .then((res) => res?.data?.updateBlock?.block);
};

export const apiDeleteBlock = (id) => {
  return client
    .mutate({
      mutation: DELETE_BLOCK,
      variables: { id },
      fetchPolicy: "no-cache",
    })
    .then((res) => res?.data?.deleteBlock?.id);
};
